<div class="container">
        <div class="row inventory-checkout-completed">
                <h2>{{'orderCompleted.heading.title' | translate}}</h2>
                <hr />
                <h3>{{'orderCompleted.heading.supportingText' | translate}} <u>{{orderId.replace('"',"")}}</u>.
                        {{'orderCompleted.heading.youWillBeLoggedOut' | translate}}</h3>
        </div>